import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentSubCategoryDto extends EpimsBaseEntityDto {
  IncidentSubCategoryName: string;
  IncidentCategoryId: string;
  SubscriptionUserId: string;
  Version: number;
}
